import styled from '@emotion/styled';

import { navAsset } from './navConfig';

const Bar = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 16px 0;
`;

const AskButton = styled.button<{ active: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 0 16px;
  border: 1px solid ${({ active }) => (active ? '#111100' : 'rgba(17, 17, 0, 0.04)')};
  border-radius: 24px;
  background: ${({ active }) => (active ? '#ffffff' : '#f8f7f7')};
  box-shadow: ${({ active }) =>
    active ? '0 0 20px 4px rgba(0, 0, 0, 0.06)' : '0 0 10px rgba(0, 0, 0, 0.06)'};
  cursor: pointer;
  font-size: 14px;
  line-height: 20px;
  color: #111100;
  transition:
    background 0.15s ease,
    border-color 0.15s ease,
    box-shadow 0.15s ease;

  &:hover {
    background: #ffffff;
  }
`;

const SearchTrigger = styled.button`
  position: absolute;
  left: 50%;
  top: 16px;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 8px;
  width: 256px;
  height: 36px;
  padding: 0 12px;
  border: 1px solid rgba(17, 17, 0, 0.04);
  border-radius: 24px;
  background: #fafafa;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: #ffffff;
  }
`;

const SearchPlaceholder = styled.span`
  font-size: 12px;
  line-height: 17.8px;
  color: rgba(17, 17, 7, 0.6);
`;

const RightGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 4px;
`;

const IconButton = styled.button`
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: rgba(17, 17, 0, 0.04);
  }
`;

const Profile = styled.button`
  position: relative;
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
`;

const BellIcon = styled.img`
  transform: scaleY(-1);
`;

const ProfileInitial = styled.span`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  color: #5a2900;
`;

type TopBarProps = {
  chatOpen: boolean;
  onToggleChat: () => void;
  onOpenSearch: () => void;
};

export function TopBar({ chatOpen, onToggleChat, onOpenSearch }: TopBarProps) {
  return (
    <Bar data-testid="nav_topbar">
      <AskButton
        type="button"
        active={chatOpen}
        onClick={onToggleChat}
        aria-pressed={chatOpen}
        data-testid="nav_topbar_ask-button"
      >
        <img src={navAsset('flodesk-ai')} alt="" width={15} height={16} />
        Ask
      </AskButton>

      <SearchTrigger
        type="button"
        onClick={onOpenSearch}
        aria-label="Search"
        data-testid="nav_topbar_search-button"
      >
        <img src={navAsset('search')} alt="" width={16} height={16} />
        <SearchPlaceholder>Search</SearchPlaceholder>
      </SearchTrigger>

      <RightGroup>
        <IconButton
          type="button"
          aria-label="Notifications"
          data-testid="nav_topbar_notifications-button"
        >
          <BellIcon src={navAsset('bell')} alt="" width={16} height={16} />
        </IconButton>
        <Profile type="button" aria-label="Your profile" data-testid="nav_topbar_profile-button">
          <img src={navAsset('profile-flower')} alt="" width={36} height={36} />
          <ProfileInitial>R</ProfileInitial>
        </Profile>
      </RightGroup>
    </Bar>
  );
}
